import React, { useContext, useEffect, useState } from "react";
import { fabric } from "@utils/fabric";
import { AppContext } from "../../context/AppContext";
import { useTranslation } from "react-i18next";

function FontSize() {
  const { canvas, selectedObject } = useContext(AppContext);
  const { t } = useTranslation();
  const [fontSize, setFontSize] = useState(
    (selectedObject as fabric.Textbox)?.get("fontSize")
  );

  // triggered by clicking layers
  useEffect(() => {
    setFontSize((selectedObject as fabric.Textbox)?.get("fontSize"));
  }, [selectedObject]);

  function onChange(event: React.ChangeEvent<HTMLInputElement>) {
    const value = parseInt(event.target.value, 10);
    setFontSize(value);
    (selectedObject as fabric.Textbox)?.set({ fontSize: value });
    canvas?.renderAll();
  }

  return (
    <input
      type="number"
      onChange={onChange}
      value={fontSize}
      min={1}
      className="w-full h-9 px-3 text-sm border border-gray-300 rounded-lg bg-white focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200"
      placeholder={t("font_size_placeholder")}
    />
  );
}

export default FontSize;
